<iframe [width]="width" [height]="height" [src]="src | safe"></iframe>
